import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/43.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Pijawki"
            question="Dokąd idziesz dalej?"
            audio={audio}
            answers={{
                ans1: "Na mały rynek.",
                ans2: "Na długi rynek.",
                ans3: "Do karczmy pani Jasińskiej."
            }}
            links={{
                link1: PAGES.p83,
                link2: PAGES.p84,
                link3: PAGES.p87
            }}
            content={
                <div>
                    <ul>
                        <li>Proszę uprzejmie – uśmiecha się szczerbaty handlarz, chowając pieniądze do sakiewki.</li>
                        <li>Do czego mogę je… – odwracasz do niego jeszcze raz, ale widzisz tylko pustą skrzynkę po owocach, na której siedział.</li>
                    </ul>
                </div>
            }
        />

    );
}